import styled from 'styled-components';
const StyledListContainer = styled.div``;

export default StyledListContainer;
